import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

import { FilterOption } from '../types';

interface RadioFilterProps {
  options: FilterOption[];
  selectedValue: string | undefined;
  onSelectionChange: (value: string | undefined) => void;
}

export const RadioFilter = ({ options, selectedValue, onSelectionChange }: RadioFilterProps) => {
  const handleValueChange = (value: string) => {
    onSelectionChange(value);
  };

  return (
    <div className="p-1 pb-2">
      <RadioGroup value={selectedValue || ''} onValueChange={handleValueChange}>
        {options.map((option) => {
          const Icon = option.icon;

          return (
            <div
              key={option.value}
              className="group flex h-8 items-center gap-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background"
            >
              <RadioGroupItem id={`filter-${option.value}`} value={option.value} />
              <Label
                htmlFor={`filter-${option.value}`}
                className="flex flex-1 cursor-pointer items-center gap-2"
              >
                {Icon &&
                  (typeof Icon === 'string' ? (
                    <span className="text-lg">{Icon}</span>
                  ) : (
                    <Icon className="h-4 w-4 text-foreground-muted" />
                  ))}
                <span className="text-sm leading-5">{option.label}</span>
              </Label>
            </div>
          );
        })}
      </RadioGroup>
    </div>
  );
};
